<template>
    <transition-group tag="div" :name="transition">
        <div v-for="(item, index) of queue" :key="item.id">
            <slot name="item" v-bind="item" :index="index" :close="() => $store.commit('queue/remove', {ns, id: item.id})"/>
        </div>
    </transition-group>
</template>

<script>
    export default {
        props: {
            ns: {type: String, required: true},
            count: {type: [Number, String], default: null},
            transition: {type: String, default: null},
        },

        computed: {
            queue() {
                return this.$store.getters['queue/get'](this.ns, this.count);
            },
        },
    };
</script>